import React from "react";
// import styled from "styled-components";
import GitHubCalendar from 'react-github-calendar';
// import {GithubContribution} from 'react-github-contributions-component'
const Github = () => {
  return (
    <>
      <h1>Github</h1>
      <picture
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
          flexWrap: "wrap",
        }}
      >
        <source
          srcset="https://github-readme-stats.vercel.app/api?username=ace0012&show_icons=true&theme=dark"
          media="(prefers-color-scheme: dark)"
        />
        <source
          srcset="https://github-readme-stats.vercel.app/api?username=ace0012&show_icons=true"
          media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
        />
        <img src="" alt="" />

        {/* <img src="https://github-readme-stats.vercel.app/api?username=ace0012&show_icons=true" /> */}
        <a href="https://github.com/Ace0012/github-readme-stats" >
          {/* <img al
  ign="center" src="https://github-readme-stats.vercel.app/api/pin/?username=ace0012&repo=github-readme-stats" /> */}

          <img
            align="center"
            src="https://github-readme-stats.vercel.app/api/top-langs?username=ace0012&show_icons=true&locale=en"
            alt="ace0012"
          />
        </a>
        {/* <img align="center" src="https://github-readme-streak-stats.herokuapp.com/?user=ace0012&" alt="ace0012" /> */}
        <a href="https://camo.githubusercontent.com/9a06f54644e11b12ebc832e72f987ea68052a21fe3977d453add4a97f4fb7de0/68747470733a2f2f6769746875622d726561646d652d73747265616b2d73746174732e6865726f6b756170702e636f6d2f3f757365723d6163653030313226" target="_blank">
          <img
            src="https://camo.githubusercontent.com/9a06f54644e11b12ebc832e72f987ea68052a21fe3977d453add4a97f4fb7de0/68747470733a2f2f6769746875622d726561646d652d73747265616b2d73746174732e6865726f6b756170702e636f6d2f3f757365723d6163653030313226"
            alt=""
          />
        </a>
        <GitHubCalendar username="ace0012" />

        {/* <!-- Optionally, include the theme (if you don't want to struggle to write the CSS) --> */}
      </picture>
      
    </>
  );
};

export default Github;
